export function init() {
	Array.from(document.querySelectorAll('.js-video'))
		.forEach((video => createPlayer(video)));
}

function createPlayer(element) {
	let player = element.querySelector('video');
	let playButton = element.querySelector('.js-video-play');

	if (!player || !playButton) {
		return;
	}

	player.setAttribute('tabindex', 0);

	function togglePlayPause() {
		player.paused ? player.play() : player.pause();
	}

	element.addEventListener('click', togglePlayPause);

	element.addEventListener('keydown', event => {
		if (event.code !== 'Enter' && event.code !== 'Space') {
			return;
		}

		togglePlayPause();
		event.preventDefault();
	}, true);

	player.addEventListener('playing', () => {
		player.focus();
		element.classList.add('is-playing');
	});

	player.addEventListener('pause', () => {
		element.classList.remove('is-playing');
	});
}
